/**
 * Utilitários de formatação para o Portal da Clínica / Parceiros
 * Segue estritamente as regras de formatação (formating.md):
 * - CNPJ, CPF, Telefone e CEP sempre formatados
 */

export function formatCpf(val?: string | null): string {
  if (!val) return '';
  const digits = val.replace(/\D/g, '');
  if (digits.length !== 11) return val;
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formatCnpj(val?: string | null): string {
  if (!val) return '';
  const digits = val.replace(/\D/g, '');
  if (digits.length !== 14) return val;
  return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function formatCpfCnpj(val?: string | null): string {
  if (!val) return '';
  const digits = val.replace(/\D/g, '');
  if (digits.length === 11) return formatCpf(digits);
  if (digits.length === 14) return formatCnpj(digits);
  return val;
}

export function formatPhone(val?: string | null): string {
  if (!val) return '';
  const digits = val.replace(/\D/g, '');
  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }
  return val;
}

export function formatCep(val?: string | null): string {
  if (!val) return '';
  const digits = val.replace(/\D/g, '');
  if (digits.length !== 8) return val;
  return digits.replace(/(\d{5})(\d{3})/, '$1-$2');
}

export function formatDateBR(val?: string | Date | null): string {
  if (!val) return '—';
  if (typeof val === 'string') {
    const raw = val.split('T')[0];
    const parts = raw.split('-');
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  }
  const d = new Date(val);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

export const formatCPF = formatCpf;
export const formatCNPJ = formatCnpj;
export const formatCEP = formatCep;
